function asId(value) {
  return String(value ?? '').trim()
}

function mapAccount(raw) {
  if (raw == null) {
    return null
  }
  if (typeof raw !== 'object') {
    const id = asId(raw)
    return id ? { id, currency: '', balance: null, description: '' } : null
  }
  const id = asId(raw.id ?? raw._id)
  if (!id) {
    return null
  }
  const balance = Number(raw.balance)
  return {
    id,
    currency: asId(raw.currency_code ?? raw.currency).toLowerCase(),
    balance: Number.isFinite(balance) ? balance : null,
    description: String(raw.description ?? '').trim(),
  }
}

export function mapAdminWallet(raw) {
  if (!raw || typeof raw !== 'object') {
    return null
  }

  const accountsRaw = Array.isArray(raw.account_details)
    ? raw.account_details
    : Array.isArray(raw.accounts)
      ? raw.accounts
      : []

  const accounts = accountsRaw.map(mapAccount).filter(Boolean)

  return {
    id: asId(raw.id ?? raw._id),
    type: asId(raw.ext_type ?? raw.type),
    userId: asId(raw.user_id ?? raw.userId),
    description: asId(raw.description),
    accounts,
    createdAt: raw.created_at ?? raw.createdAt ?? null,
    updatedAt: raw.updated_at ?? raw.updatedAt ?? null,
  }
}
